import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ciao-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.less'],
    standalone: false
})
export class HelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
